import { Trash2Icon } from 'lucide-react'

import { Button } from '@/components/ui'
import type { Transaction } from '@/modules/projects'
import { formatDate } from '@/utils'
import { printedPositionLabel } from '../../reconciliation/helpers'
import { InlineNumber } from './InlineNumber'

export const TransactionRow = ({
  row,
  onEditAmount,
  onRemove,
  onJump,
}: {
  row: Transaction
  onEditAmount: (next: number) => void
  onRemove: () => void
  onJump: (page: number | null, fileUrl: string) => void
}) => {
  const printedPosition = printedPositionLabel(row)

  return (
    <tr className="border-t">
      <td className="whitespace-nowrap py-1.5 pr-3 text-left tabular-nums">
        {row.sourcePage != null ? (
          <button
            type="button"
            onClick={() => onJump(row.sourcePage, row.statementFileUrl)}
            title="Show this row on the statement"
            className="cursor-pointer text-muted-foreground hover:text-foreground hover:underline"
          >
            {row.date ? formatDate(row.date) : '--'}
          </button>
        ) : (
          <span className="text-muted-foreground">
            {row.date ? formatDate(row.date) : '--'}
          </span>
        )}
        {printedPosition && (
          <span
            title="Page and printed position on that page"
            className="ml-1.5 text-[10px] text-muted-foreground"
          >
            {printedPosition}
          </span>
        )}
      </td>
      <td className="py-1.5 pr-3 text-left text-foreground">
        {row.description}
      </td>
      <td className="w-32 py-1.5 pl-3 text-right">
        <InlineNumber value={row.amount} onCommit={onEditAmount} />
      </td>
      <td className="py-1.5 pl-2 text-right">
        <Button
          theme="ghost"
          size="sm"
          isIcon
          className="cursor-pointer text-muted-foreground hover:text-destructive"
          onClick={onRemove}
        >
          <Trash2Icon className="size-3.5" />
          <span className="sr-only">Remove row</span>
        </Button>
      </td>
    </tr>
  )
}
